<template>
  <div>
    <div class="list">
      <div class="list_listpapers_biaoti">
		  <div class="list_listpapers_biaoti_1">试卷列表</div>
      <div class="list_listpapers_biaoti_2">{{loginUser}}&nbsp;&nbsp;{{realUser}}</div>
	  </div>
      <div v-if="success" class="list_listpapers_neirong">
        <div>
          <div class="list_title">
            <div class="list_title_name borderright" :class="{list_title_actived: unFinish}" v-on:click="isUnFinished">正在考试</div>
            <div class="list_title_name" :class="{list_title_actived: finished}"  v-on:click="isFinished">已考试</div>
            <!-- <div class="list_title_name" :class="{list_title_actived: allPapers}" v-on:click="all">全部</div> -->
          </div>
        </div>
        <ul v-show="allPapers">
          <router-link :to="'/single/' + item.paperId" tag="li"  class="list_listpapers_neirong-li" replace v-for="item of datas" :key="item.paperId">
            <span v-if="item.paperLx == 0 || item.paperLx == 1">
              <div class="list_listpapers_neirong-title">{{item.paperNr}}&nbsp;<mt-badge v-if="item.paperLx === 0" size="small" color="#f86767">总分:{{item.paperZfs}}</mt-badge>
                <mt-badge v-if="item.paperLx === 1" size="small" color="#f86767">问卷调查</mt-badge>
              </div>
              <div class="list_listpapers_neirong_shijian">试卷有效时间：{{getCustomDate(item.paperKssj)}}&nbsp;~&nbsp;{{getCustomDate(item.paperJssj)}}</div>
              <div v-if="isSplit" class="list_listpapers_split"></div>
            </span>
          </router-link>
          <!-- <li v-if="datas.length<=0">没有信息</li> -->
        </ul>

        <ul v-show="unFinish">
          <router-link :to="'/single/' + item.paperId" tag="li"  class="list_listpapers_neirong-li" replace v-for="item of unFinishedPapers" :key="item.paperId">
            <span v-if="item.paperLx == 0 || item.paperLx == 1">
              <div class="list_listpapers_neirong-title">{{item.paperNr}}&nbsp;<mt-badge v-if="item.paperLx === 0" size="small" color="#f86767">总分:{{item.paperZfs}}</mt-badge>
                <mt-badge v-if="item.paperLx === 1" size="small" color="#f86767">问卷调查</mt-badge>
              </div>
              <div class="list_listpapers_neirong_shijian">试卷有效时间：{{getCustomDate(item.paperKssj)}}&nbsp;~&nbsp;{{getCustomDate(item.paperJssj)}}</div>
              <div v-if="isSplit" class="list_listpapers_split"></div>
            </span>
          </router-link>
          <!-- <li v-if="unFinishedPapers.length<=0">没有未考试信息</li> -->
        </ul>

        <ul v-show="finished" >
          <!-- <router-link :to="'/single/' + item.paperId" tag="li"  class="list_listpapers_neirong-li" replace v-for="item of finishedPapers" :key="item.paperId"> -->
          <li  class="list_listpapers_neirong-li" replace v-for="item of finishedPapers" :key="item.paperId">
            <span v-if="item.paperLx == 0 || item.paperLx == 1">
              <div class="list_listpapers_neirong-title">{{item.paperNr}}&nbsp;&nbsp;<mt-badge v-if="item.paperLx === 0" size="small" color="#f86767">最高分:{{item.zgfs}}</mt-badge>
                <mt-badge v-if="item.paperLx === 1" size="small" color="#f86767">问卷调查</mt-badge>
              </div>
              <div class="list_listpapers_neirong_shijian">试卷有效时间：{{getCustomDate(item.paperKssj)}}&nbsp;~&nbsp;{{getCustomDate(item.paperJssj)}}</div>
              <div v-if="isSplit" class="list_listpapers_split"></div>
            </span>
          </li>
          <li v-if="finishedPapers.length<=0">没有已考试信息</li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { post, fetchUrl } from '@/assets/js/network.js'
import { Toast, Badge } from 'mint-ui'
Vue.component(Badge.name, Badge)
export default {
  name: 'Home',
  data () {
    return {
      isSplit: true,
      datas: [],
      finishedPapers: [],
      unFinishedPapers: [],
      success: false,
      noPaper: '',
      allPapers: false,
      finished: false,
      unFinish: true,
      src: require('../assets/images/bottom.png'),
      src1: require('../assets/images/bottom.png'),
      right: require('../assets/images/right.png'),
      bottom: require('../assets/images/bottom.png'),
      user: null
    }
  },
  mounted () {
    if (!this.$store.state.loginUser.userDl) {
      this.$router.replace('/')
      return
    }
    this.user = this.$store.state.loginUser
    this.ListData()
  },
  computed: {
    loginUser () {
      return this.user ? this.user.userDl : ' '
    },
    realUser () {
      return this.user ? this.user.userMc : ' '
    }
  },
  methods: {
    ListData () {
      var _this = this
      var myMap = {'userDl': '', 'userMm': ''}
      post(fetchUrl('/api/newexamination/getPaperAll'), myMap, function (responseCode, message) {
        if (responseCode === 0 && message.length !== 0) {
          const datas = JSON.parse(message)
          if (datas.data.length > 0) {
            _this.success = true
            _this.userPaper()
          } else {
            _this.noPaper = '当前没有考试信息'
          }
          _this.datas = datas.data
          _this.$store.commit('change', datas.data)
        } else {
          Toast({message: '获取考试列表失败，请联系管理员!'})
        }
      })
    },
    userPaper () {
      let ur = this.$store.state.user
      if (ur) {
        let _this = this
        let myMap = {'User_ID': ur.id}

        post(fetchUrl('/api/newexamination/getPaperUserAll'), myMap, function (responseCode, message) {
          if (responseCode === 0 && message.length !== 0) {
            let datas = JSON.parse(message)
            // -----------------------------------------------2021年1月21日，旧代码注释开始-----------------------------
            // if (_this.datas.length > 0 && datas.data) {
            //   // console.log(datas)
            //   _this.datas.forEach(item => {
            //     if (datas.data.length > 0) {
            //       datas.data.forEach(newItem => {
            //         let status = false
            //         let zgfs = 0
            //         let kscs = 0
            //         if (item.paperId === newItem.Paper_ID) {
            //           status = true
            //           zgfs = newItem.zgfs
            //           kscs = newItem.kscs
            //           _this.finishedPapers.push({paperId: item.paperId, paperNr: item.paperNr, paperKssj: item.paperKssj, paperJssj: item.paperJssj, paperZfs: item.paperZfs, paperLx: item.paperLx, status: status, zgfs: zgfs, kscs: kscs})
            //         }
            //       })
            //     }
            //   })
            // }
            // if (_this.finishedPapers.length > 0) {
            //   _this.datas.forEach(item => {
            //     let flag = true
            //     for (let i = 0; i < _this.finishedPapers.length; i++) {
            //       if (item.paperId === _this.finishedPapers[i].paperId) {
            //         flag = false
            //         break
            //       }
            //     }
            //     if (flag) {
            //       _this.unFinishedPapers.push({paperId: item.paperId, paperNr: item.paperNr, paperKssj: item.paperKssj, paperJssj: item.paperJssj, paperZfs: item.paperZfs, paperLx: item.paperLx, status: false, zgfs: 0, kscs: 0})
            //     }
            //   })
            // } else {
            //   _this.datas.forEach(item => {
            //     _this.unFinishedPapers.push({paperId: item.paperId, paperNr: item.paperNr, paperKssj: item.paperKssj, paperJssj: item.paperJssj, paperZfs: item.paperZfs, paperLx: item.paperLx, status: false, zgfs: 0, kscs: 0})
            //   })
            // }
            // -----------------------------------------------2021年1月21日，旧代码注释结束-----------------------------

            // -----------------------------------------------2021年1月21日，医院要求展示所有已经考试过的试卷列表，新代码开始-----------------------------
            if (datas.data.length > 0) {
              datas.data.forEach(item => {
                if (item.Paper_LX === 0 || item.Paper_LX === 1) {
                  _this.finishedPapers.push({paperId: item.Paper_ID, paperNr: item.Paper_NR, paperKssj: item.Paper_KSSJ, paperJssj: item.Paper_JSSJ, paperLx: item.Paper_LX, status: true, zgfs: item.zgfs, kscs: item.kscs})
                }
              })

              _this.finishedPapers.sort(function (a, b) { return Date.parse(b.paperJssj) - Date.parse(a.paperJssj) })
            }

            _this.datas.forEach(item => {
              _this.unFinishedPapers.push({paperId: item.paperId, paperNr: item.paperNr, paperKssj: item.paperKssj, paperJssj: item.paperJssj, paperZfs: item.paperZfs, paperLx: item.paperLx, status: false, zgfs: 0, kscs: 0})
            })

            // -----------------------------------------------2021年1月21日，医院要求展示所有已经考试过的试卷列表，新代码结束-----------------------------
          } else {
            Toast('获取分类数据失败！')
          }
        })
      }
    },
    all () {
      this.allPapers = true
      this.finished = false
      this.unFinish = false
    },
    isUnFinished () {
      this.allPapers = false
      this.finished = false
      this.unFinish = true
    },
    isFinished () {
      this.allPapers = false
      this.finished = true
      this.unFinish = false
    },
    getCustomDate: function (dt) {
      var cusDate = dt.substring(0, 10)
      return cusDate
    }
  }
}
</script>

<style lang="stylus" scoped>
  .list
    .list_listpapers_biaoti
      margin-bottom: .3rem
      color: #fff
      text-align: center
      padding: 10px
      border-bottom: 1px solid gray
      background: #00bcd4
      .list_listpapers_biaoti_1
        font-size: .4rem
      .list_listpapers_biaoti_2
        padding-top : 10px
        color: #e8e8e8
        text-align: right
    .list_listpapers_neirong
      padding-left: .4rem
      padding-right: .4rem
      .list_title
        display: flex
        font-size: .35rem
        margin-bottom: 10px
        .list_title_name
          flex: 1
          text-align: center
          padding: 8px
        .list_title_actived
          background-color: #CCCCCC
        .borderright
          border-right: 1px solid #CCCCCC
      .list_listpapers_neirong-li
        margin-bottom: .2rem
        .list_listpapers_neirong-title
          line-height: .5rem
          font-size: .35rem
        .list_listpapers_neirong_shijian
          font-size: .2rem
          color: gray
          padding-top: 5px
      .list_listpapers_split
        width: 100%;
        height: 0
        padding-top: .06rem
        border-bottom: 1px solid #bbbbbb
    .list_listpapers_neirong_error
      padding-left: .4rem
      padding-right: .4rem
      font-size: .35rem
</style>



// WEBPACK FOOTER //
// src/home/ListPaper.vue